import { SplixerResourceInterface } from './splixer-resource.interface';
import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  uNumber,
  uString,
  Uuid,
} from '@hidat/huijs-common';
import { HasTenantResource, ResourceConfig } from '@hidat/huijs-resource';

export const TenantSettingConfig = new ResourceConfig(
  'TenantSetting',
  'tenant_settings',
  true,
  true,
).addFields([
  new FieldConfig('category', FieldDataTypes.STRING, false),
  new FieldConfig('section', FieldDataTypes.STRING, false),
  new FieldConfig('klass', FieldDataTypes.STRING, false),
  new FieldConfig('settings', FieldDataTypes.UNKNOWN),
]);

/**
 * Tenant Settings Interface
 * Object based settings/configurations for a tenant.
 */
export interface TenantSettingInterface
  extends SplixerResourceInterface<Uuid>, HasTenantResource {
  category: uString;
  section: uString;
  klass: uString;
  settings: AnyHash | undefined;
  version: uNumber;
}
